<div class="icon" *ngIf="icon && showIcon">
  <ng-content select="rt-icon"></ng-content>
</div>

<div class="text-content">
  <ng-content></ng-content>
</div>

<div class="icon-help" *ngIf="iconHelp">
  <ng-content select="rt-icon-help"></ng-content>
</div>

<div class="badge" *ngIf="badge">
  <ng-content select="rt-badge"></ng-content>
</div>
